import React, { useEffect, useState } from 'react';
import api from '@utils/axios';
import { apiInternalVisitPath } from 'routes';
import EditVisitModal from '../EditVisitModal';
import { TimeZoneContextProvider } from '@contexts/timezone-context';
import { TenantContextProvider } from '@contexts/tenant-context';
import '../Visits.scss';

const defaultState = {
  workOrderId: null,
  subcontractors: null,
  technicians: null,
  priorities: null,
  timeZones: null,
  visit: null,
  visitStatuses: null,
  defaultTechnicianId: null,
  defaultSubcontractorId: null,
  isSubcontractorsEnabled: false
};

export default function EditVisit({ defaultTimeZone, timeZonesMapping }) {
  const [visitProps, setVisitProps] = useState(defaultState);
  const isOpen = !!visitProps.visit;

  useEffect(() => {
    function handleOpenModal(event) {
      api
        .get(apiInternalVisitPath({ id: event.detail }), { params: { modal: true } })
        .then((response) => {
          setVisitProps({
            visit: response.data.visit,
            workOrderId: response.data.woId,
            subcontractors: response.data.vendorOptions,
            technicians: response.data.techOptions,
            priorities: response.data.priorityOptions,
            timeZones: response.data.timeZoneOptions,
            visitStatuses: response.data.statusesOptions,
            defaultTechnicianId: response.data.defaultTechnicianId,
            defaultSubcontractorId: response.data.defaultSubcontractorId,
            isSubcontractorsEnabled: response.data.isSubcontractorsEnabled
          });
        })
        .catch((error) => {
          console.error('Error fetching visit props:', error);
        });
    }
    function handleCloseModal() {
      setVisitProps(defaultState);
    }

    window.addEventListener('openVisitModal', handleOpenModal);
    window.addEventListener('closeVisitModal', handleCloseModal);

    return () => {
      window.removeEventListener('openVisitModal', handleOpenModal);
      window.removeEventListener('closeVisitModal', handleCloseModal);
    };
  }, []);

  const onEditComplete = () => {
    window.dispatchEvent(new CustomEvent('visitUpdated'));
    setVisitProps(defaultState);
  };

  return visitProps.visit ? (
    <TimeZoneContextProvider initialTimeZone={defaultTimeZone} timeZonesMapping={timeZonesMapping}>
      <TenantContextProvider>
        <EditVisitModal
          woId={visitProps.workOrderId}
          vendorOptions={visitProps.subcontractors}
          techOptions={visitProps.technicians}
          priorityOptions={visitProps.priorities}
          timeZoneOptions={visitProps.timeZones}
          visit={visitProps.visit}
          isOpen={isOpen}
          onClose={() => setVisitProps(defaultState)}
          statusesOptions={visitProps.visitStatuses}
          onEditComplete={onEditComplete}
          defaultTechnicianId={visitProps.defaultTechnicianId}
          defaultSubcontractorId={visitProps.defaultSubcontractorId}
          isSubcontractorsEnabled={visitProps.isSubcontractorsEnabled}
        />
      </TenantContextProvider>
    </TimeZoneContextProvider>
  ) : (
    <br />
  );
}
